import axios, { AxiosError, AxiosResponse } from 'axios';
import { Envelope } from '../interfaces/envelope';
import deinitialization from './deinitialization';

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

axios.interceptors.response.use(
	(response: AxiosResponse) => {
		return response;
	},
	(error: AxiosError<Envelope<null>>) => {
		if (error.response?.status === 401) {
			deinitialization.userLogout(true);
		}
		return Promise.reject(error);
	}
);
